module.exports = __webpack_public_path__ + "static/media/Ball.7b287cf2.png";